import React from 'react';
import { ShowTutorsOnSlotModal } from './show-tutors-on-slot-modal.component';
import { useShowTutorsOnSlotModalService } from './show-tutors-on-slot-modal.service';
import type { ShowTutorsOnSlotModalContainerProps } from './show-tutors-on-slot-modal.types';

export const ShowTutorsOnSlotModalContainer = (
  props: ShowTutorsOnSlotModalContainerProps,
) => {
  const serviceProps = useShowTutorsOnSlotModalService(props);
  return <ShowTutorsOnSlotModal {...serviceProps} />;
};
